document.addEventListener("algolia.hooks.initialize", function () {
  // console.log(
  //   "Algolia Autocomplete:",
  //   window.algoliaShopify?.externals?.autocomplete
  // );

  // console.log("✅ DOM Loaded - Attaching Algolia Autocomplete");

  const searchInput = document.querySelector(".search-header__input");

  if (!searchInput) {
    console.error("❌ Search input field not found!");
    return;
  }

  // console.log("🔍 Search input found:", searchInput);

  // Ensure Algolia Autocomplete is available
  if (
    !window.algoliaShopify ||
    !window.algoliaShopify.externals ||
    !window.algoliaShopify.externals.autocomplete
  ) {
    console.error("❌ Algolia Autocomplete is not available!");
    return;
  }

  const autocomplete = window.algoliaShopify.externals.autocomplete;

  // Attach Algolia Autocomplete to the input
  autocomplete({
    container: searchInput,
    placeholder: "Search...",
    insights: true,
    debug: true, // Enables console logs for debugging
  });
});

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteOptions",
    function (options) {
      // Change the placeholder text of the autocomplete menu
      options.placeholder = "Search our products";
      // change the .aa-Panel class to .aa-Panel--custom
      options.id = "valk-flyout";
      // set autoFocus to true
      options.autoFocus = true;
      return options;
    }
  );
});

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (
      _defaultTemplate,
      templateOptions,
      distinct,
      itemLink,
      trackSearchAttribution
    ) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      // console.log("item", item);

      let ratingValue = 0;
      let maxRating = 5; // Default max rating
      if (item.meta?.reviews?.rating) {
        try {
          const ratingData = JSON.parse(item.meta.reviews.rating);
          ratingValue = parseFloat(ratingData.value) || 0;
          maxRating = parseFloat(ratingData.scale_max) || 5;
        } catch (error) {
          console.error("Error parsing rating data:", error);
        }
      }
      return html`
        <div class="product-tile">
          <div class="item-product">
            <div class="thumbnail-container has-multiimage">
              <a
                href="${itemLink}"
                class="aa-ItemLink aa-ProductItem"
                onClick="${() => trackSearchAttribution(item)}"
              >
                <div class="respone_image" style="padding-top:100.0%;">
                  <img
                    class="product__thumbnail lazyautosizes lazyloaded"
                    src="${item.image}"
                    alt="${item.title}"
                    sizes="212px"
                  />
                </div>
              </a>
            </div>

            <div class="product__info">
              <div class="product__title">
                <a
                  href="${algoliaShopify.helpers.instantsearchLink(item)}"
                  title="${algoliaShopify.helpers.fullTitle(
                    item.title,
                    item._distinct
                  )}"
                >
                  ${components.Highlight({ hit: item, attribute: "title" })}
                </a>
              </div>

              <!-- Availability -->
              <div class="available_product d-flex">
                <span
                  class="product__available ${item.inventory_available
                    ? "in-stock"
                    : "sold-out"}"
                >
                  <span
                    >${item.inventory_available
                      ? "In stock"
                      : "Out of stock"}</span
                  >
                </span>
              </div>

              <div
                class="rating jdgm-widget"
                data-id="${item.id}"
                data-template="search"
              >
                ${item.meta?.reviews?.rating
                  ? html`
                      <span
                        class="jdgm-prev-badge__stars"
                        data-score="${ratingValue.toFixed(2)}"
                        tabindex="0"
                        aria-label="${ratingValue.toFixed(2)} stars"
                        role="button"
                      >
                        ${Array.from(
                          { length: maxRating },
                          (_, i) => html`
                            <span
                              class="jdgm-star ${i < ratingValue
                                ? "jdgm--on"
                                : "jdgm--off"}"
                            ></span>
                          `
                        )}
                      </span>
                    `
                  : ""}
              </div>

              <div class="price-box">
                <div class="price-sale">
                  <span class="special-price">
                    ${algoliaShopify.helpers.displayPrice(item, distinct)}
                  </span>
                  ${item.meta?.custom?.rrp
                    ? html`
                        <div class="ais-hit--rrp">
                          <span class="ais-hit--rrp-price">
                            $${Number(item.meta.custom.rrp).toFixed(2)}
                          </span>
                          <span class="ais-hit--rrp-label">RRP</span>
                        </div>
                      `
                    : ""}
                  ${item.compare_at_price
                    ? html` <span class="old-price"
                        >was
                        ${algoliaShopify.helpers.displayStrikedPrice(
                          item.price,
                          item.compare_at_price
                        )}</span
                      >`
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    }
  );
});
